import {
  UPDATE_APPOINTMENT_SESSIONS,
  FETCH_APPOINTMENT_NOTES,
  UPDATE_ASSESSMENT_SCORE,
  FETCH_APPOINTMENT_SUCCESS,
  FETCH_VIDEO_TOKEN_REQUEST,
  FETCH_VIDEO_TOKEN_SUCCESS,
  FETCH_VIDEO_TOKEN_FAILURE,
} from '../actions/types';

const initialState = {
  videoToken: null,
  videoTokenLoading: false,
  videoTokenError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENT_SUCCESS:
      return { ...state, appointment: action.payload.data };
    case FETCH_VIDEO_TOKEN_REQUEST:
      return {
        ...state,
        videoToken: initialState.videoToken,
        videoTokenLoading: true,
        videoTokenError: false,
      };
    case FETCH_VIDEO_TOKEN_SUCCESS:
      return {
        ...state,
        videoToken: action.payload.data,
        videoTokenLoading: false,
        videoTokenError: false,
      };
    case FETCH_VIDEO_TOKEN_FAILURE:
      return {
        ...state,
        videoToken: initialState.videoToken,
        videoTokenLoading: false,
        videoTokenError: true,
      };
    case UPDATE_APPOINTMENT_SESSIONS:
      return { ...state, sessions: action.payload.data };
    case FETCH_APPOINTMENT_NOTES:
      return { ...state, appointment_notes: action.payload.data };
    case UPDATE_ASSESSMENT_SCORE:
      return { ...state, assessment_scores: action.payload.data };
    default:
      return state;
  }
};
